import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../content/SiteContext';
import { whatsappLink } from '../lib/contact';

const Footer = () => {
  const { BUSINESS, CITIES, SERVICE_PAGES } = useSite();
  return (
  <footer className="site-footer">
    <div className="container">
      <div className="site-footer__grid">
        <div className="site-footer__brand">
          <Link to="/" className="brand brand--light" aria-label="Quick Way home">
            <img src="/img/mark-96.png" alt="" width="40" height="40" loading="lazy" />
            <span>Quick Way</span>
          </Link>
          <p>Mobile car wash and detailing at your home, building or office in Abu Dhabi and Dubai.</p>
          <a href={BUSINESS.playStore} target="_blank" rel="noopener noreferrer" className="store-badge">
            <img src="/img/google-play.png" alt="Get the Quick Way app on Google Play" width="150" height="45" loading="lazy" />
          </a>
        </div>
        <div>
          <h2 className="site-footer__title">Services</h2>
          <ul>
            {SERVICE_PAGES.map((s) => <li key={s.slug}><Link to={`/services/${s.slug}`}>{s.name}</Link></li>)}
            <li><Link to="/pricing">Prices and packages</Link></li>
            <li><Link to="/membership">Monthly car wash plans</Link></li>
            <li><Link to="/corporate-fleet-car-wash">Corporate and fleet</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="site-footer__title">Areas</h2>
          <ul>
            {CITIES.map((c) => <li key={c.id}><Link to={c.path}>Mobile car wash {c.name}</Link></li>)}
            <li><Link to="/locations">All service areas</Link></li>
          </ul>
          <h2 className="site-footer__title">Company</h2>
          <ul>
            <li><Link to="/car-wash-app">Car wash app</Link></li>
            <li><Link to="/about">About Quick Way</Link></li>
            <li><Link to="/how-it-works">How it works</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/partner">Become a partner</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="site-footer__title">Contact</h2>
          <ul>
            <li><a href={`tel:${BUSINESS.phone}`}>{BUSINESS.phoneDisplay}</a></li>
            <li><a href={whatsappLink()} target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
            <li><a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></li>
            <li><a href={BUSINESS.facebook} target="_blank" rel="noopener noreferrer">Facebook</a></li>
          </ul>
        </div>
      </div>
      <div className="site-footer__bottom">
        <p>&copy; {new Date().getFullYear()} Quick Way. All rights reserved.</p>
        <ul>
          <li><Link to="/privacy-policy">Privacy policy</Link></li>
          <li><Link to="/terms">Terms and conditions</Link></li>
          <li><Link to="/cancellation-policy">Cancellation and refunds</Link></li>
        </ul>
      </div>
    </div>
  </footer>
);
};

export default Footer;
